import { useMemo } from "react";
import { useSearchParams } from "react-router-dom";
import AdminDashboard from "./AdminDashboard";
import AdminOpsCenter from "./AdminOpsCenter";
import AdminLogs from "./AdminLogs";
import AdminAlerts from "./AdminAlerts";
import { useAdminSession } from "../context/AdminSessionContext";
import { hasPermission } from "../utils/permissionHelpers";
import WorkspaceShell from "../Components/ui/WorkspaceShell";

type OpsTabKey = "dashboard" | "ops-center" | "logs" | "alerts";

export default function AdminWorkspaceOps() {
  const [params, setParams] = useSearchParams();
  const { session } = useAdminSession();
  const permissions = useMemo(() => session?.permissions ?? [], [session?.permissions]);

  const tabs = useMemo(
    () =>
      [
        { key: "dashboard", label: "Dashboard", allow: hasPermission(permissions, "Dashboard.View"), render: <AdminDashboard /> },
        { key: "ops-center", label: "Ops Center", allow: hasPermission(permissions, "Dashboard.View"), render: <AdminOpsCenter /> },
        { key: "logs", label: "Logs", allow: hasPermission(permissions, "Logs.View"), render: <AdminLogs /> },
        { key: "alerts", label: "Alerts", allow: hasPermission(permissions, "Notifications.View"), render: <AdminAlerts /> },
      ] as const,
    [permissions],
  );

  const available = tabs.filter((tab) => tab.allow);
  const requested = (params.get("tab") ?? "dashboard") as OpsTabKey;
  const active = available.find((tab) => tab.key === requested) ?? available[0];

  if (!active) {
    return <div className="admin-soft-alert text-sm">Bu workspace icin yetkin bulunmuyor.</div>;
  }

  const setTab = (key: string) => {
    const next = new URLSearchParams(params);
    next.set("tab", key);
    setParams(next, { replace: true });
  };

  return (
    <WorkspaceShell
      title="Ops Workspace"
      subtitle="Canli sistem sagligi, log akislari, alarmlar ve operasyonel mudahale tek merkezde."
      tabs={available.map((tab) => ({ key: tab.key, label: tab.label }))}
      activeKey={active.key}
      onTabChange={setTab}
      statPills={
        <>
          <span className="admin-pill">Realtime izleme</span>
          <span className="admin-pill">Hata analizi</span>
          <span className="admin-pill">Alarm yonetimi</span>
        </>
      }
    >
      {active.render}
    </WorkspaceShell>
  );
}
